import React, { useContext } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { AppContext } from '../../../../AppContext';
import AccessControl from '../../../../AccessControl';
import {
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
  USER_ROLES,
} from '../../../../common/constants';
import Error404 from '../../../../Error404';
import './ambassadors.less';
import Ambassadors from './pages/Ambassadors';
import CreateAmbassador from './pages/CreateAmbassador';
import EditAmbassador from './pages/EditAmbassador';
import ViewAmbassador from './pages/ViewAmbassador';

const AmbassadorsWrapper = () => {
  const { getCurrentUser } = useContext(AppContext);
  const { roles } = getCurrentUser() || {};
  const isSuperAdmin = roles?.includes(USER_ROLES?.SUPER_ADMIN?.key);

  if (!isSuperAdmin) {
    return <Redirect to={ROUTES?.MAIN} />;
  }

  return (
    <Switch>
    <Route
      exact
      path={`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS}>
          <Ambassadors {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}/add`}
      render={(props) => (
        <AccessControl
          permissionType={PERMISSION_TYPE?.CREATE}
          permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS}
        >
          <CreateAmbassador {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}/edit/:id`}
      render={(props) => (
        <AccessControl
          permissionType={PERMISSION_TYPE?.UPDATE}
          permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS}
        >
          <EditAmbassador {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.SYSTEM_USERS}${ROUTES?.AMBASSADORS}/view/:id`}
      render={(props) => (
        <AccessControl permissionKey={PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS}>
          <ViewAmbassador {...props} />
        </AccessControl>
      )}
    />
    <Route path="*" exact component={Error404} />
  </Switch>
  );
};

export default AmbassadorsWrapper;
